import authService from './AuthService';

class ApiInterceptor {
  constructor() {
    this.setupInterceptors();
  }

  setupInterceptors() {
    const originalFetch = window.fetch;

    window.fetch = async (url, options = {}) => {
      try {
        const response = await originalFetch(url, options);

        const requestUrl = typeof url === 'string' || url instanceof URL
          ? url.toString()
          : url.url;
        const shouldSkipAuthRedirect = requestUrl.includes('/api/artifacts/');

        if (response.status === 401 && !shouldSkipAuthRedirect) {
          await this.handleUnauthorized();
          return response;
        }

        return response;
      } catch (error) {
        console.error('API request failed:', error);
        throw error;
      }
    };
  }

  async handleUnauthorized() {
    authService.updateState(null);

    if (window.location.pathname !== '/') {
      window.location.href = '/';
    }
  }
}

const apiInterceptor = new ApiInterceptor();

export default apiInterceptor;
